import * as React from "react";
import * as ReactDOM from "react-dom";

import GuiReport from "./components/GuiReport";

import { getUrlVars } from "./helpers";

const projectId = parseInt(getUrlVars().get("projectId"));
const protectiveFunctionId = parseInt(getUrlVars().get("protectiveFunctionId"));

ReactDOM.render(
  <GuiReport
    projectId={projectId}
    protectiveFunctionId={protectiveFunctionId}
  />,
  document.getElementById("gui-report")
);